// extracted by mini-css-extract-plugin
export default {"root":"EmployedsList_root__uF2Dm","root_nothing":"EmployedsList_root_nothing__XPJJM"};